import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ApiConfig } from "./api.config.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";
import { ApiBaseService } from "./api.base.service";
/**
 * Generic HTTP data service to be used by all other services
 */
@Injectable({
  providedIn: "root",
})
export class ApiPosService extends ApiBaseService {
  constructor(
    http: HttpClient,
    config: ApiConfig,
    spinner: NgxSpinnerService,
    toastr: ToastrService,
    trans: TranslateService
  ) {
    super(http, spinner, toastr, trans, config);
    this.urlBase = config.posApiUrl;
    this.config.posApiUrlChanged.subscribe((e) => {
      this.urlBase = e;
    });
  }

  public get posApiUrl() {
    return this.urlBase;
  }
}
